import React, { useCallback, useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress } from "@mui/material";
import withAlert from '../../hoc/withAlert'

import api from "../../api/api";

import { useSelector } from 'react-redux';




const ImageInlineAws = ({ label, name, value, editId, updateInline, AppAlert,module, fileId, onSuccess,thumb=true}) => {
                        

  
  const [dialogStatus, setDialogStatus] = useState(false);
  const [uploadInProgress, setUploadProgress] = useState(null);
  const [inputValue,setInputValue] = useState(value);
  const [imagePath,setImagePath] = useState(null);
  const [uploaded ,setUploadStatus] =  useState(false);

  const authUser = useSelector((state) => state.auth)
  const userId=  authUser.id;

  
  const isImage = (file) =>{
    if(file.type.match('image.*')){
        return true;
    }
    return false;
  }
  

  const startUpload = (e) =>{

    if(!isImage(e.target.files[0])){
        AppAlert("Invalid File Type","error");
        return false;
    }
    
    //console.log("I am ahere");
    let data = new FormData();
    data.append('tmpFile', e.target.files[0]);
    data.append('module',module);
    data.append('editId',editId);
    data.append('fileId',fileId);

    setUploadStatus(false);
    api.post("upload/aws/image",data,{
        onUploadProgress: (progressEvent) => { 
            const { loaded, total } = progressEvent;
            let percent = Math.floor((loaded * 100) / total);
            //console.log(percent);
            setUploadProgress(percent)
        }
    }).then( (res)=>{
        

          setUploadProgress(null)
          setUploadStatus(true);
          setInputValue(res.data.filePath);
          setTimeout(()=>{
            setImagePath(res.data.filePath);  
          },100)
          


        console.log("here in upload aws success",res);
    }).catch( (error) => {
        setUploadProgress(null)
        console.log(error);
        
    })

  }

  const addNew = ()=>{
      setDialogStatus(true)
  }

  const handleClose  = () =>{
      setDialogStatus(false);
  }

  const prepairImagePath = useCallback(() =>{
    if(inputValue){
        console.log("inputValue is",inputValue)
      setImagePath(inputValue);
    } else {
      setImagePath("/images/blank-profile.png")
    }
  },[inputValue])



  const  updateImage = () =>{
    let data = {};
    data[name] = inputValue;
    data['id'] = editId;
    
    let payload = {
            data:data,
            type:"awsimage",
            editId:editId,
            userId:userId,
        }
    updateInline(payload).then(res=>{
        AppAlert("Updated Successfully")
        onSuccess();
    }).catch(error => {
        AppAlert(error.msg);
    })
  }

  useEffect(()=>{
    prepairImagePath();
  },[prepairImagePath])


  const [imageDialogStatus,setImageDialogStatus] = useState(false);
  

  return (
    <>
          {thumb &&
          <div className="v2-img-container" style={{width:"100%"}}>
              <img className="v2-image"  src={imagePath} alt={label} />
              <div className="v2-middle">
                <button type="button" className="btn btn-danger btn-sm m-1" onClick={addNew}>Change</button>
                <button type="button" className="btn btn-warning btn-sm m-1" onClick={()=>setImageDialogStatus(true)}>View</button>
            </div>
          </div>
          }
          {!thumb &&
            <>
            {imagePath!=="/images/blank-profile.png" && <a className="btn btn-primary btn-sm me-2"  href={imagePath} target="_blank" > View </a> }
            {imagePath!=="/images/blank-profile.png" && <button type="button" className="btn btn-danger btn-sm m-1" onClick={addNew}>Update</button> }
            {imagePath==="/images/blank-profile.png" && <button type="button" className="btn btn-danger btn-sm m-1" onClick={addNew}>Add {label}</button> }
            </>
          }
      

          <Dialog
              open={imageDialogStatus}
              keepMounted
              onClose={()=>setImageDialogStatus(false)}
              fullWidth={true}
              maxWidth="lg"
              aria-describedby="alert-dialog-slide-description"
          >
            <img  src={imagePath} alt={label} />
          </Dialog>

          <Dialog
              open={dialogStatus}
              keepMounted
              onClose={handleClose}
              fullWidth={true}
              maxWidth="md"
              aria-describedby="alert-dialog-slide-description"
          >

          <DialogTitle>{"Update "+label}</DialogTitle>
              <DialogContent>

                <div className="row">
                

                { uploadInProgress !== null && uploadInProgress < 100 && <LinearProgress variant="determinate" value={uploadInProgress} /> }
                { uploadInProgress === null && <img className="img-thumbnail v2-thumb" src={imagePath} alt={label} />}
                  
                </div>
                <div className="row">
                  <div className="col-md-12 mt-2">
                    <input type="file" onChange={ (e)=>{ startUpload(e) } } accept="image/png, image/gif, image/jpeg" />
                    { /*<label htmlFor="upload" className="btn btn-primary  float-end">Choose File</label> */ }
                  </div>
                  
                </div>

                
                
              </DialogContent>
              <DialogActions>
                {uploaded  && <button type="button" className="btn btn-success" onClick={updateImage} >Update</button> }
                <button type="button" className="btn btn-danger" onClick={handleClose} >Close</button>
              </DialogActions>
          </Dialog>
    </>
  )
}


export default withAlert(ImageInlineAws);